import { render, staticRenderFns } from "./UserCell.vue?vue&type=template&id=183ba450&scoped=true"
import script from "./UserCell.vue?vue&type=script&lang=js"
export * from "./UserCell.vue?vue&type=script&lang=js"
import style0 from "./UserCell.vue?vue&type=style&index=0&id=183ba450&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183ba450",
  null
  
)

export default component.exports